import * as React from 'react';
import { UserHistoryItem } from '../../../../../types/UserHistory';
import { localedFormat, getReadableCardType } from '../../../../../utils';
import Card from '../../../../Feed/Card/Card';
import { parseISO } from 'date-fns';
import './UserHistoryItem.css';

interface Props {
	item: UserHistoryItem;
}

const UserHistoryItemComponent: React.FC<Props> = ({ item }) => {
	return (
		<div className="userHistrory-item">
			<div className="userHistrory-item__date">
				{localedFormat(parseISO(item.date as any), "d MMMM yyyy, HH:mm")}
			</div>

			<div className="userHistrory-item__desc">
				Книга <a href={`/book/${item.book.woo_id}/`}>{item.book.name}</a>{" "}
				добавлена в список "{getReadableCardType(item.payload.value as any)}"
			</div>

			<div className="userHistrory-item__card">
				<Card book={item.book} />
			</div>
		</div>
	);
};

export default UserHistoryItemComponent;
